import styled from 'styled-components';

interface GridProps {
  columns?: string;
  gap?: string;
  marginBottom?: string;
  padding?: string;
  background?: string;
  borderRadius?: string;
  boxShadow?: string;
}

export const Grid = styled.div<GridProps>`
  display: grid;
  grid-template-columns: ${props => props.columns || 'repeat(auto-fit, minmax(200px, 1fr))'};
  gap: ${props => props.gap || '1rem'};
  margin-bottom: ${props => props.marginBottom || '0'};
  padding: ${props => props.padding || '0'};
  background: ${props => props.background || 'transparent'};
  border-radius: ${props => props.borderRadius || '0'};
  box-shadow: ${props => props.boxShadow || 'none'};
`;

// Specialized grid variants
export const FiltersGrid = styled(Grid)`
  grid-template-columns: 2fr 1fr 1fr;
  margin-bottom: 2rem;
  padding: 1.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const StatsGrid = styled(Grid)`
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  margin-bottom: 2rem;
`;

export const FormGrid = styled(Grid)`
  grid-template-columns: 1fr 1fr;
  padding: 1.5rem;
`;